module.exports = __webpack_public_path__ + "assets/img/movie_creation_24px.svg";